/**
 * OnboardPage.tsx — ɳSentry onboarding wizard
 *
 * Purpose:    Multi-step onboarding: plugin selection, env config, verify, deploy
 * Inputs:     :step URL param from React Router (1-4)
 * Outputs:    OnboardingWizard component at the given step
 * Constraints: Client-side; React Router useParams for step
 * SOT:        T-P3-E3-W2-S5-T01
 */
import { useParams, Link } from 'react-router-dom'
import { OnboardingWizard } from '../components/OnboardingWizard'

export function OnboardPage() {
  const { step: stepParam } = useParams<{ step: string }>()
  const step = parseInt(stepParam ?? '1') || 1

  if (isNaN(step) || step < 1 || step > 4) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-brand-ink">
        <div className="text-center">
          <h1 className="mb-4 text-3xl font-bold">Invalid Step</h1>
          <p className="mb-6 text-brand-secondary">Please navigate to a valid onboarding step.</p>
          <Link
            to="/onboard/1"
            className="rounded-lg bg-sky-500 px-6 py-3 font-semibold text-white transition hover:bg-sky-400"
          >
            Start Onboarding
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-1 flex-col">
      <div className="px-4 py-12 sm:px-6 lg:px-8">
        <OnboardingWizard step={step} />
      </div>
    </div>
  )
}
